import * as React from 'react';
import { MediaQuery, SliderCarousel } from '@grandvisionhq/common';
import { RichBanner, PromotionBannersItem, HighlightedContentItem, CategoryLinksItem, CertificatesItem, PromotionBanners, HighlightedContent, CategoryLinks, Certificates } from '@grandvisionhq/content';
import { Heading, Container } from '@grandvisionhq/elements';
import { FlexLayout } from '@grandvisionhq/layout';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import { parseBloomreachImage } from '../../utils/parse-bloomreach-image.js';
import '@grandvisionhq/state';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBloomreachPageable } from '../../hocs/with-bloomreach-pageable.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';

const CmsBannerCollectionItem = withEditableContent(({ content , template  })=>{
    var ref;
    const { title , description , content: richText  } = content;
    const image = parseBloomreachImage(content.image);
    const links = useBloomreachLinks(content.links);
    const tooltip = ((ref = content.tooltip) === null || ref === void 0 ? void 0 : ref.showTooltip) ? content.tooltip : undefined;
    switch(template){
        case 'certificates':
            return /*#__PURE__*/ React.createElement(CertificatesItem, {
                image: image === null || image === void 0 ? void 0 : image.original,
                mobileImage: image === null || image === void 0 ? void 0 : image.mobile,
                link: links[0],
                title: title,
                text: description
            });
        case 'main-categories':
            return /*#__PURE__*/ React.createElement(CategoryLinksItem, {
                image: image === null || image === void 0 ? void 0 : image.original,
                link: links[0],
                title: title
            });
        case 'usp':
            return /*#__PURE__*/ React.createElement(HighlightedContentItem, {
                image: image === null || image === void 0 ? void 0 : image.original,
                link: links[0],
                title: title,
                text: description
            });
        case 'promotion-banner':
        case 'split-header-promotion':
            return /*#__PURE__*/ React.createElement(PromotionBannersItem, {
                image: image === null || image === void 0 ? void 0 : image.original,
                mobileImage: image === null || image === void 0 ? void 0 : image.mobile,
                link: links[0],
                title: title,
                text: description,
                fullWidth: template === 'split-header-promotion',
                tooltip: tooltip
            });
        case 'rich-banner':
            return /*#__PURE__*/ React.createElement(RichBanner, {
                image: image === null || image === void 0 ? void 0 : image.original,
                mobileImage: image === null || image === void 0 ? void 0 : image.mobile,
                richText: richText === null || richText === void 0 ? void 0 : richText.value,
                link: links.find((l)=>l.style === 'image'
                ),
                backgroundColor: "white",
                textColor: "black",
                bannerWidth: "full",
                layout: "collection",
                tooltip: tooltip
            });
        default:
            return null;
    }
});
const CmsBannerCollection = ({ content , template , meta  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const items = React.useMemo(()=>content.items.map((item, i)=>/*#__PURE__*/ React.createElement(CmsBannerCollectionItem, {
                key: `${item.id}-${i}`,
                content: item,
                template: template
            })
        )
    , [
        content.items,
        template
    ]);
    switch(template){
        case 'certificates':
            return /*#__PURE__*/ React.createElement(Certificates, null, items);
        case 'main-categories':
            return /*#__PURE__*/ React.createElement(CategoryLinks, null, items);
        case 'usp':
            return /*#__PURE__*/ React.createElement(HighlightedContent, null, items);
        case 'promotion-banner':
        case 'split-header-promotion':
            return /*#__PURE__*/ React.createElement(PromotionBanners, {
                fullWidth: template === 'split-header-promotion'
            }, items);
        case 'rich-banner':
            return /*#__PURE__*/ React.createElement(Container, null, isSmallScreen && meta.mobilePresentation === 'horizontal' ? /*#__PURE__*/ React.createElement(SliderCarousel, null, items) : /*#__PURE__*/ React.createElement(FlexLayout, {
                justify: "space-between",
                wrap: "wrap"
            }, items));
        default:
            return /*#__PURE__*/ React.createElement(Heading, {
                variant: "subheading1"
            }, `Banner collection with template: ${template} is not defined in CmsBannerCollection component.`);
    }
};
var CmsBannerCollection$1 = compose(withBloomreachPageable, withBreakpointVisibility, withAnchor)(CmsBannerCollection);

export { CmsBannerCollection, CmsBannerCollectionItem, CmsBannerCollection$1 as default };
//# sourceMappingURL=BannerCollection.js.map
